<script>
import CardInput from './card-input.vue'
import SecurityInformation from './security-information.vue'
import sharedService from '@/utils/shared-service'
import { EventBus } from '@/event-bus.js'
import { mapGetters } from 'vuex'
import { CONSTANT, SDK_ENUMS } from '@/utils/constant'
import checkout from '@/utils/checkout'

export default {
  name: 'GuestCheckout',
  components: {
    CardInput,
    SecurityInformation
  },
  data () {
    return {
      close: true,
      error: '',
      CONSTANT: CONSTANT,
      prevRoute: null,
      isCardValid: true
    }
  },

  computed: {
    ...mapGetters(['srciActionCode']),

    authFailed () {
      return (this.srciActionCode === SDK_ENUMS.SrciActionCodes.authFailed)
    }

  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.$store.dispatch('isError', false)
  },

  mounted () {
    EventBus.$on('handleError', (event) => {
      this.error = event
    })
  },

  methods: {

    /**
     * This method routes to the previous screen
     */
    goBack () {
      if (this.prevRoute && this.prevRoute.path.includes('otp-methods')) {
        sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.OTP_METHOD_SCREEN, this.$router)
      } else {
        window.close()
        EventBus.$emit('switchPage', CONSTANT.INLINE_SCREEN.OTP_METHOD_SCREEN)
      }
    },

    /**
     * This method emit add card and calls enroll sdk
     */
    submit () {
      this.addCard()
    },

    /**
     * This method calls the add card api which internal calls enroll card
     */
    async addCard () {
      try {
        let cardDetails = {
          primaryAccountNumber: sharedService.unmask(this.$refs.cardNumber.cardNumber),
          panExpirationMonth: this.$refs.securityInfo.expiry.split('/')[0],
          panExpirationYear: `${new Date().getFullYear().toString().substr(0, 2)}${this.$refs.securityInfo.expiry.split('/')[1]}`,
          cardSecurityCode: this.$refs.securityInfo.cvc2,
          network: this.$refs.cardNumber.cardType
        }
        this.isCardValid = sharedService.validateCardDetails(cardDetails)
        if (this.isCardValid) {
          await this.checkout(cardDetails)
        }
      } catch (error) {
        console.log(error)
        this.error = error.errors[0].reason
        EventBus.$emit('handleError', this.error)
      }
    },

    /**
     * This method calls the checkout when user adds new card
     * @param cardDetail
     * @returns {Promise<void>}
     */
    async checkout (cardDetail) {
      if (!window.opener) {
        sharedService.invokeSrc(false, CONSTANT.SRC.INLINE_CARD, this.$store)
      }
      let windowRef = !window.opener ? checkout : window.opener.checkout
      await windowRef.initiate({
        cardDetail,
        enrollCard: true,
        srciActionCode: this.srciActionCode
      })
    }
  }
}
</script>

<template>
  <div>
    <div
      v-if="error"
      id="addCardErrorMessage"
      class="enroll-card-sdk-error alert alert-danger"
      role="alert"
    >
      {{ $t('errorMessages.' +error) }}
    </div>
    <div class="pb-3">
      <div class="form-group mt-4">
        <h4 class="font-weight-bold">
          {{ $t ('label.addInfo') }}
        </h4>
        <label v-if="authFailed">
          {{ $t ('errorMessages.AUTH_FAILED_ERROR') }}
        </label>
        <div class="mt-5">
          <card-input
            ref="cardNumber"
          />
        </div>
      </div>
      <security-information
        ref="securityInfo"
      />
    </div>
    <div class="text-center mt-5 pt-3">
      <button
        id="add-card-btn"
        class="btn btn-dark lightbox-btn btn-lg"
        data-test="btn-continue"
        type="submit"
        @click="submit()"
      >
        {{ $t ('label.addCard') }}
      </button>
      <div
        v-if="!authFailed"
        class="text-center mt-2"
      >
        <span
          class="btn-footer"
          @click="goBack()"
        >
          {{ $t('label.goBack') }}
        </span>
      </div>
    </div>
  </div>
</template>
